import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50727984"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    class: "link__wrapper",
    href: _ctx.link.link,
    target: "_blank"
  }, [
    _createElementVNode("div", {
      class: "link__link",
      style: _normalizeStyle({
        backgroundColor: _ctx.link.backgroundColor,
        color: _ctx.colorText,
      })
    }, _toDisplayString(_ctx.link.name), 5)
  ], 8, _hoisted_1))
}